// Auto-generated API manifest (subset)
// Contains only agent metadata and the versioning islands the frontend needs.
// The full manifest (models, CRUD operations, queries, etc.) is served at GET /api/manifest.
// DO NOT EDIT - Changes will be overwritten by codegen

export interface AgentInfo {
  name: string;
  task_class_name: string;
  description: string;
  label: string;
  icon: string;
  roles: string[];
  default: boolean;
}

export const agents: AgentInfo[] = [
  {
    "name": "general-chat",
    "task_class_name": "ChatTask",
    "description": "General purpose chat agent",
    "label": "General Chat",
    "icon": "message-square",
    "roles": [],
    "default": false
  },
  {
    "name": "skills-chat",
    "task_class_name": "ChatSkillsTask",
    "description": "Dynamic skills-based chat agent that discovers capabilities on demand",
    "label": "Skills Chat",
    "icon": "sparkles",
    "roles": [],
    "default": false
  },
  {
    "name": "rflp",
    "task_class_name": "RFLPTask",
    "description": "Systems-engineering assistant: requirements \u2192 functional \u2192 logical \u2192 physical. Gemini-backed, skills-driven.",
    "label": "RFLP",
    "icon": "network",
    "roles": [],
    "default": true
  }
];

/** Look up agent info by task class name. */
export function getAgentByTaskClass(taskClassName: string): AgentInfo | undefined {
  return agents.find(a => a.task_class_name === taskClassName);
}

// ---- Versioning islands (masterplan 67 §15; one computation with the
// ---- startup validator — sourcepilot/versioning/manifest.py) ----

export interface IslandSpec {
  root_mro: string[];
  /** null = keep-everything (the default; 67 §4) */
  policies: { op_retention: string | null; commit_on_save: boolean; constraint_gate: boolean };
  member_types: string[];
  up_pointers: Record<string, string>;
  /** the concrete root types filed under this island (a ChatSkillsTask under "TaskNode") */
  types: string[];
}

export interface VersioningManifest {
  schema_version: string;
  /** island key (the most specific declaring root its types share, or a subtype whose island differs) -> spec */
  islands: Record<string, IslandSpec>;
  /** concrete root type name -> its island key */
  island_of_type: Record<string, string>;
  versioned_out: string[];
  /** versioned-out RECORD classes (the AttachedRecord family: attachment = the pin-registry row) */
  records: string[];
  /** per claim class: how its STALE claims show by default (user settings override), and whether they are sent by default (`send_stale`; a subscription may choose) */
  claims: Record<string, { stale: "note" | "hide"; send_stale: boolean }>;
}

export const versioningManifest: VersioningManifest = {
  "schema_version": "afc590285ac1",
  "islands": {
    "Attribute": {
      "root_mro": [
        "Attribute",
        "CatalogNode",
        "IslandRoot",
        "RFLPElement"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": true,
        "constraint_gate": false
      },
      "member_types": [
        "AttributeValue",
        "DerivedExpression",
        "DerivedValue",
        "IslandPin"
      ],
      "up_pointers": {
        "AttributeValue": "owner",
        "DerivedExpression": "result",
        "DerivedValue": "owner",
        "IslandPin": "holder"
      },
      "types": [
        "Attribute",
        "DiscreteAttribute",
        "NumericAttribute"
      ]
    },
    "GlossaryTerm": {
      "root_mro": [
        "GlossaryTerm",
        "CatalogNode",
        "IslandRoot",
        "RFLPElement"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": true,
        "constraint_gate": false
      },
      "member_types": [
        "AttributeValue",
        "DerivedExpression",
        "DerivedValue",
        "IslandPin"
      ],
      "up_pointers": {
        "AttributeValue": "owner",
        "DerivedExpression": "result",
        "DerivedValue": "owner",
        "IslandPin": "holder"
      },
      "types": [
        "GlossaryTerm"
      ]
    },
    "Item": {
      "root_mro": [
        "Item",
        "CatalogNode",
        "IslandRoot",
        "RFLPElement"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": true,
        "constraint_gate": false
      },
      "member_types": [
        "AttributeValue",
        "DerivedExpression",
        "DerivedValue",
        "IslandPin"
      ],
      "up_pointers": {
        "AttributeValue": "owner",
        "DerivedExpression": "result",
        "DerivedValue": "owner",
        "IslandPin": "holder"
      },
      "types": [
        "Item"
      ]
    },
    "LLMTask": {
      "root_mro": [
        "LLMTask",
        "IslandRoot",
        "ScopedNode",
        "PrivateNode"
      ],
      "policies": {
        "op_retention": "recent-window",
        "commit_on_save": false,
        "constraint_gate": false
      },
      "member_types": [
        "Answer",
        "IslandPin",
        "ModelRequest",
        "ModelResponse",
        "Question",
        "Questionnaire",
        "Step",
        "TaskHistory",
        "TextPart",
        "ThinkingPart",
        "Thread",
        "ToolCallPart",
        "ToolCallResponse"
      ],
      "up_pointers": {
        "Answer": "question",
        "IslandPin": "holder",
        "ModelRequest": "step",
        "ModelResponse": "model_request",
        "Question": "questionnaire",
        "Questionnaire": "tool_call_part",
        "Step": "thread",
        "TaskHistory": "task",
        "TextPart": "model_response",
        "ThinkingPart": "model_response",
        "Thread": "task",
        "ToolCallPart": "model_response",
        "ToolCallResponse": "tool_call"
      },
      "types": [
        "ActionValidationTask",
        "AttributeExpansionTask",
        "ComponentExtractionTask",
        "ComponentMatchTask",
        "DanglingPortResolutionTask",
        "DeduplicationTask",
        "ExtractionSummaryTask",
        "FunctionMatchTask",
        "FunctionalBlockExtractionTask",
        "InquiriesSummaryTask",
        "InquirySolvingTask",
        "InterfaceExpansionTask",
        "MainPortExtractionTask",
        "MaterialExtractionTask",
        "NodeMergeTask",
        "PortConnectionTask",
        "PortExpansionTask",
        "ProductExtractionTask",
        "ProductMatchTask",
        "RequirementExtractionTask",
        "RequirementMatchTask",
        "RequirementSatisfactionTask",
        "SemanticMapSummaryTask",
        "StatementSplitTask",
        "StatementsSummaryTask",
        "ThreadTask",
        "UpdatesSummaryTask",
        "ValidationTask"
      ]
    },
    "Material": {
      "root_mro": [
        "Material",
        "CatalogNode",
        "IslandRoot",
        "ScopedNode"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": true,
        "constraint_gate": false
      },
      "member_types": [
        "IslandPin"
      ],
      "up_pointers": {
        "IslandPin": "holder"
      },
      "types": [
        "Material"
      ]
    },
    "PDMProduct": {
      "root_mro": [
        "PDMProduct",
        "SysMLStructure",
        "SysMLClassifier",
        "SysMLType"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": false,
        "constraint_gate": false
      },
      "member_types": [
        "IslandPin",
        "PDMAction",
        "PDMPart",
        "PDMPort",
        "PDMRequirement",
        "PDMSupplyChainCriteria"
      ],
      "up_pointers": {
        "IslandPin": "holder",
        "PDMAction": "parent_action",
        "PDMPart": "parent_part",
        "PDMPort": "part",
        "PDMRequirement": "parent_requirement",
        "PDMSupplyChainCriteria": "parent_requirement"
      },
      "types": [
        "PDMProduct"
      ]
    },
    "Project": {
      "root_mro": [
        "Project",
        "RFLPElement",
        "IslandRoot",
        "ScopedNode"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": false,
        "constraint_gate": true
      },
      "member_types": [
        "Action",
        "ActionInputParameter",
        "ActionOutputParameter",
        "AttributeValue",
        "ChangeProposal",
        "Concern",
        "Connection",
        "Constraint",
        "ControlPort",
        "DerivedExpression",
        "DerivedValue",
        "InterfacePort",
        "IslandPin",
        "ItemFlow",
        "LogicalPart",
        "PhysicalPart",
        "PhysicsPort",
        "ProposalBatch",
        "Requirement",
        "SoftwarePart",
        "StakeholderNeed",
        "Succession"
      ],
      "up_pointers": {
        "Action": "parent",
        "ActionInputParameter": "owner_action",
        "ActionOutputParameter": "owner_action",
        "AttributeValue": "owner",
        "ChangeProposal": "batch",
        "Concern": "container",
        "Connection": "port_a",
        "Constraint": "formalises",
        "ControlPort": "owner",
        "DerivedExpression": "result",
        "DerivedValue": "owner",
        "InterfacePort": "owner",
        "IslandPin": "holder",
        "ItemFlow": "source_parameter",
        "LogicalPart": "parent",
        "PhysicalPart": "parent",
        "PhysicsPort": "owner",
        "ProposalBatch": "project",
        "Requirement": "container",
        "SoftwarePart": "parent",
        "StakeholderNeed": "container",
        "Succession": "parent_action"
      },
      "types": [
        "Project"
      ]
    },
    "SourceDocument": {
      "root_mro": [
        "SourceDocument",
        "CatalogNode",
        "IslandRoot",
        "RFLPElement"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": true,
        "constraint_gate": false
      },
      "member_types": [
        "AttributeValue",
        "DerivedExpression",
        "DerivedValue",
        "IslandPin"
      ],
      "up_pointers": {
        "AttributeValue": "owner",
        "DerivedExpression": "result",
        "DerivedValue": "owner",
        "IslandPin": "holder"
      },
      "types": [
        "SourceDocument"
      ]
    },
    "Standard": {
      "root_mro": [
        "Standard",
        "CatalogNode",
        "IslandRoot",
        "RFLPElement"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": true,
        "constraint_gate": false
      },
      "member_types": [
        "AttributeValue",
        "DerivedExpression",
        "DerivedValue",
        "IslandPin"
      ],
      "up_pointers": {
        "AttributeValue": "owner",
        "DerivedExpression": "result",
        "DerivedValue": "owner",
        "IslandPin": "holder"
      },
      "types": [
        "Standard"
      ]
    },
    "SystemPrompt": {
      "root_mro": [
        "SystemPrompt",
        "IslandRoot",
        "ScopedNode",
        "PrivateNode"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": true,
        "constraint_gate": false
      },
      "member_types": [
        "IslandPin"
      ],
      "up_pointers": {
        "IslandPin": "holder"
      },
      "types": [
        "SystemPrompt"
      ]
    },
    "TaskNode": {
      "root_mro": [
        "TaskNode",
        "IslandRoot",
        "ScopedNode",
        "PrivateNode"
      ],
      "policies": {
        "op_retention": "recent-window",
        "commit_on_save": false,
        "constraint_gate": false
      },
      "member_types": [
        "Answer",
        "IslandPin",
        "ModelRequest",
        "ModelResponse",
        "Question",
        "Questionnaire",
        "Step",
        "TaskHistory",
        "TextPart",
        "ThinkingPart",
        "Thread",
        "ToolCallPart",
        "ToolCallResponse"
      ],
      "up_pointers": {
        "Answer": "question",
        "IslandPin": "holder",
        "ModelRequest": "step",
        "ModelResponse": "model_request",
        "Question": "questionnaire",
        "Questionnaire": "tool_call_part",
        "Step": "thread",
        "TaskHistory": "task",
        "TextPart": "model_response",
        "ThinkingPart": "model_response",
        "Thread": "task",
        "ToolCallPart": "model_response",
        "ToolCallResponse": "tool_call"
      },
      "types": [
        "ChatSkillsTask",
        "ChatTask",
        "FunctionalBreakdownTask",
        "ModularBreakdownTask",
        "ModularRequirementAnalysisTask",
        "PartAllocationTask",
        "PartBreakdownTask",
        "PartPerformsTask",
        "ProductQueryExtractionTask",
        "ProductRequirementsAnalysisTask",
        "ProductSupplyChainAnalysisTask",
        "RFLPTask",
        "TaskNode"
      ]
    },
    "Unit": {
      "root_mro": [
        "Unit",
        "CatalogNode",
        "IslandRoot",
        "RFLPElement"
      ],
      "policies": {
        "op_retention": null,
        "commit_on_save": true,
        "constraint_gate": false
      },
      "member_types": [
        "AttributeValue",
        "DerivedExpression",
        "DerivedValue",
        "IslandPin"
      ],
      "up_pointers": {
        "AttributeValue": "owner",
        "DerivedExpression": "result",
        "DerivedValue": "owner",
        "IslandPin": "holder"
      },
      "types": [
        "Unit"
      ]
    }
  },
  "island_of_type": {
    "ActionValidationTask": "LLMTask",
    "Attribute": "Attribute",
    "AttributeExpansionTask": "LLMTask",
    "ChatSkillsTask": "TaskNode",
    "ChatTask": "TaskNode",
    "ComponentExtractionTask": "LLMTask",
    "ComponentMatchTask": "LLMTask",
    "DanglingPortResolutionTask": "LLMTask",
    "DeduplicationTask": "LLMTask",
    "DiscreteAttribute": "Attribute",
    "ExtractionSummaryTask": "LLMTask",
    "FunctionMatchTask": "LLMTask",
    "FunctionalBlockExtractionTask": "LLMTask",
    "FunctionalBreakdownTask": "TaskNode",
    "GlossaryTerm": "GlossaryTerm",
    "InquiriesSummaryTask": "LLMTask",
    "InquirySolvingTask": "LLMTask",
    "InterfaceExpansionTask": "LLMTask",
    "Item": "Item",
    "MainPortExtractionTask": "LLMTask",
    "Material": "Material",
    "MaterialExtractionTask": "LLMTask",
    "ModularBreakdownTask": "TaskNode",
    "ModularRequirementAnalysisTask": "TaskNode",
    "NodeMergeTask": "LLMTask",
    "NumericAttribute": "Attribute",
    "PDMProduct": "PDMProduct",
    "PartAllocationTask": "TaskNode",
    "PartBreakdownTask": "TaskNode",
    "PartPerformsTask": "TaskNode",
    "PortConnectionTask": "LLMTask",
    "PortExpansionTask": "LLMTask",
    "ProductExtractionTask": "LLMTask",
    "ProductMatchTask": "LLMTask",
    "ProductQueryExtractionTask": "TaskNode",
    "ProductRequirementsAnalysisTask": "TaskNode",
    "ProductSupplyChainAnalysisTask": "TaskNode",
    "Project": "Project",
    "RFLPTask": "TaskNode",
    "RequirementExtractionTask": "LLMTask",
    "RequirementMatchTask": "LLMTask",
    "RequirementSatisfactionTask": "LLMTask",
    "SemanticMapSummaryTask": "LLMTask",
    "SourceDocument": "SourceDocument",
    "Standard": "Standard",
    "StatementSplitTask": "LLMTask",
    "StatementsSummaryTask": "LLMTask",
    "SystemPrompt": "SystemPrompt",
    "TaskNode": "TaskNode",
    "ThreadTask": "LLMTask",
    "Unit": "Unit",
    "UpdatesSummaryTask": "LLMTask",
    "ValidationTask": "LLMTask"
  },
  "versioned_out": [
    "ActionRoot",
    "ActionUsage",
    "AnalysisRecord",
    "AttributeDefinition",
    "AttributeUsage",
    "CalculationState",
    "ChangeImpact",
    "ConstraintDefinition",
    "ConstraintUsage",
    "ControlFlow",
    "DataFlow",
    "DatabaseReference",
    "FluidFlow",
    "FunctionalModule",
    "FunctionalSubsystem",
    "Group",
    "Industry",
    "InterfaceDefinition",
    "Invite",
    "ItemDefinition",
    "ItemUsage",
    "MBSE_Action",
    "MBSE_Attribute",
    "MBSE_Package",
    "MBSE_Part",
    "MBSE_Port",
    "MBSE_Requirement",
    "Organisation",
    "PDMItemFlow",
    "PartUsage",
    "PortDefinition",
    "PortUsage",
    "PowerFlow",
    "RequirementDefinition",
    "RequirementUsage",
    "SimpleFunctionalDependency",
    "SysMLBehavior",
    "SysMLClassifier",
    "SysMLConstraint",
    "SysMLExpression",
    "SysMLFeature",
    "SysMLNamespace",
    "SysMLStructure",
    "SysMLType",
    "SysMLUnit",
    "SysMLUsage",
    "TaskResult",
    "TaskRun",
    "User",
    "VersioningBranch",
    "VersioningCommit",
    "VersioningOp",
    "VersioningOrigin",
    "VersioningOverlay",
    "VersioningPin",
    "VersioningRelease",
    "Workspace"
  ],
  "records": [
    "AnalysisRecord",
    "ChangeImpact"
  ],
  "claims": {
    "AnalysisRecord": {
      "stale": "note",
      "send_stale": true
    },
    "ChangeImpact": {
      "stale": "note",
      "send_stale": true
    }
  }
};

/** Island-root type names whose island can contain `typeName`
 *  (multi-root: dual-home types list every candidate; a root lists itself). */
export function islandRootsForType(typeName: string): string[] {
  const roots: string[] = [];
  const own = versioningManifest.island_of_type[typeName];
  if (own) roots.push(own);
  for (const [root, spec] of Object.entries(versioningManifest.islands)) {
    if (root !== own && spec.member_types.includes(typeName)) roots.push(root);
  }
  return roots;
}

/** True when `typeName` is a versioned island root (its own history, branches, commits). */
export function isIslandRoot(typeName: string): boolean {
  return typeName in versioningManifest.island_of_type;
}

/** True when changes to `typeName` are outside version control entirely. */
export function isVersionedOut(typeName: string): boolean {
  return versioningManifest.versioned_out.includes(typeName);
}
